import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

class ListItem extends React.PureComponent {

  static propTypes = {
    body: PropTypes.string,
    description: PropTypes.string,
    gallery: PropTypes.string,
    itemType: PropTypes.string,
    list: PropTypes.string,
    name: PropTypes.string,
    price: PropTypes.string,
    region: PropTypes.object,
    sweetness: PropTypes.string,
    template: PropTypes.string,
    type: PropTypes.string,
    unit: PropTypes.string
  };

  checkWineProps() {

    if (this.props.itemType === 'wine') { // IT's a WINE
      if (this.props.list !== 'true') { // NOT A LIST
        return (
          <div className="wine-props">
            <div>
              <FormattedMessage id="type">
                {(message) => <h4 className="prop-label">{message}</h4>}
              </FormattedMessage>
              {this.props.type}
            </div>
            {this.props.region ? 
            <div>
              <FormattedMessage id="region">
                {(message) => <h4 className="prop-label">{message}</h4>}
              </FormattedMessage>
              {this.props.region.name} <span className="contry-code">{this.props.region.country_code}</span>
            </div> : null
            }
            {/* <div>
              <FormattedMessage id="body">
                {(message) => <h4 className="prop-label">{message}</h4>}
              </FormattedMessage>
              {this.props.body}
            </div>
            <div>
              <FormattedMessage id="accidity">
                {(message) => <h4 className="prop-label">{message}</h4>}
              </FormattedMessage>
              {this.props.sweetness}
            </div> */}
          </div>
        );
      }
      else { // ITs BEING RENDERED IN A LIST
        return (
          <div>
            <p className="type">{this.props.type}</p>
            <p className="region">{this.props.region.name},
              <span className="contry-code">{this.props.region.country_code}</span>
            </p>
          </div>
        );
      }
    }
  }

  render() {
    return (
      <div>
        <img src={this.props.gallery} alt={this.props.name} className="item-thumbnail"/>
        <div className="item-info">
          <h5 className="item-title">{this.props.name}
          {
          this.props.price ? 
          <span className="price">{this.props.price}€{this.props.unit === 'Kg' ? '/Kg' : null}</span>:
          <FormattedMessage id="price_under_request">
            {(message) => <span className="price">
            {message}
          </span>}
          </FormattedMessage>
          
          }
            
          </h5>
          {
            this.props.list !== 'true' ?
            <span dangerouslySetInnerHTML={{ __html: this.props.description}}/>
              :
              null
          }
          {this.checkWineProps()}
        </div>
      </div>
    );
  }
}

export default ListItem;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/core/ListItem.js
 **/